import { useState, useEffect } from 'react';

export const useTimer = (isPlaying: boolean, isPaused: boolean) => {
  const [counter, setCounter] = useState(0);
  
  // Set up counter interval
  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    
    if (isPlaying && !isPaused) {
      interval = setInterval(() => {
        setCounter(prevCounter => prevCounter + 1);
      }, 1000);
    }
    
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isPlaying, isPaused]);

  // Format counter as HH:MM:SS
  const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return {
    counter,
    setCounter,
    formatTime
  };
}; 